import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = Swiper;
